import React from 'react';
import { Box, Chip } from '@mui/material';
import LocalParkingIcon from '@mui/icons-material/LocalParking';
import WifiIcon from '@mui/icons-material/Wifi';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import AccessibleIcon from '@mui/icons-material/Accessible';
import ChildFriendlyIcon from '@mui/icons-material/ChildFriendly';
import PetsIcon from '@mui/icons-material/Pets';
import TvIcon from '@mui/icons-material/Tv';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import LocalCafeIcon from '@mui/icons-material/LocalCafe';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import NewspaperIcon from '@mui/icons-material/Newspaper';
import MusicNoteIcon from '@mui/icons-material/MusicNote';
import SmokingRoomsIcon from '@mui/icons-material/SmokingRooms';
import { Amenities } from '../../types/shop';

const amenityConfig: {
  [key: string]: { label: string; icon: React.ReactNode };
} = {
  parking: { label: 'Parking', icon: <LocalParkingIcon fontSize="small" /> },
  wifi: { label: 'WiFi', icon: <WifiIcon fontSize="small" /> },
  airConditioning: {
    label: 'Air Conditioning',
    icon: <AcUnitIcon fontSize="small" />,
  },
  wheelchairAccessible: {
    label: 'Wheelchair Accessible',
    icon: <AccessibleIcon fontSize="small" />,
  },
  kidsFriendly: {
    label: 'Kids Friendly',
    icon: <ChildFriendlyIcon fontSize="small" />,
  },
  petFriendly: { label: 'Pet Friendly', icon: <PetsIcon fontSize="small" /> },
  tv: { label: 'TV', icon: <TvIcon fontSize="small" /> },
  magazines: { label: 'Magazines', icon: <MenuBookIcon fontSize="small" /> },
  beverages: { label: 'Beverages', icon: <LocalCafeIcon fontSize="small" /> },
  games: { label: 'Games', icon: <SportsEsportsIcon fontSize="small" /> },
  books: { label: 'Books', icon: <LibraryBooksIcon fontSize="small" /> },
  newspapers: {
    label: 'Newspapers',
    icon: <NewspaperIcon fontSize="small" />,
  },
  music: { label: 'Music', icon: <MusicNoteIcon fontSize="small" /> },
  smokingArea: {
    label: 'Smoking Area',
    icon: <SmokingRoomsIcon fontSize="small" />,
  },
};

interface PublicAmenitiesListProps {
  amenities?: Amenities;
}

/**
 * Read-only, compact chip list of the amenities a shop has enabled.
 * Mirrors the icon/label set used in the private `ShopAmenities` form
 * without any editing capability.
 */
const PublicAmenitiesList: React.FC<PublicAmenitiesListProps> = ({
  amenities,
}) => {
  if (!amenities) return null;

  const enabled = Object.keys(amenityConfig).filter(
    (key) => amenities[key as keyof Amenities] === true
  );

  if (enabled.length === 0) return null;

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
      {enabled.map((key) => (
        <Chip
          key={key}
          icon={amenityConfig[key].icon as React.ReactElement}
          label={amenityConfig[key].label}
          size="small"
          sx={{
            bgcolor: 'rgba(255,255,255,0.08)',
            color: '#fff',
            '& .MuiChip-icon': { color: '#dd8709' },
          }}
        />
      ))}
    </Box>
  );
};

export default PublicAmenitiesList;
